// tuning/input.ts (M0-T06, §7.2)
import type { TuningBank } from '../schema/tuning';

export default { joystickZone: 0.45, joystickRadiusPx: 50, runDeflection: 0.95, tapMaxMs: 250, tapMaxPx: 10 } as const satisfies TuningBank;   // tap*: rev 7 item 32
